import { createApp } from "vue"
// import { createApp, configureCompat } from "vue"
import App from './App.vue'
import router from './router'
import store from './store'

// // デフォルトですべてを Vue 3 の動作にして、特定の機能の互換性のみを有効化
// configureCompat({
//   MODE: 3,

//   /* v-bindでの属性=false時の挙動が変更されておりエラーとなってしまうため互換モードとする(警告は表示される)
//      https://v3-migration.vuejs.org/ja/breaking-changes/attribute-coercion.html*/
//   // ATTR_FALSE_VALUE: true,
  
//   /* Vue 3.0 からフィルターは削除されたためエラーとなり起動できなくため互換モードとする
//     https://v3-migration.vuejs.org/ja/breaking-changes/filters.html */
//   // FILTERS: true,
//   // COMPILER_FILTERS:true,

//   /* イベントAPIのインスタンスメソッドが削除されたため互換モードとする
//      tiny-emitterの導入でも行けそう
//      https://v3-migration.vuejs.org/ja/breaking-changes/events-api.html */
//   // INSTANCE_EVENT_EMITTER:true,

//   /* Vue.prototype が config.globalProperties に置き換わったことによる影響
//     どこで使っているかは不明のため互換モードとする
//     https://v3-migration.vuejs.org/ja/breaking-changes/global-api.html#vue-prototype-replaced-by-config-globalproperties */
//   // GLOBAL_PROTOTYPE:true,

//   /* v-modelの仕様変更による影響。互換モードとする
//     https://v3-migration.vuejs.org/ja/breaking-changes/v-model.html */
//   // COMPONENT_V_MODEL:true,
//   // COMPILER_V_BIND_SYNC:true,

// })

const app = createApp(App)

import filter from './plugin/filter'
app.config.globalProperties.$filter = filter

import log from './plugin/log'
app.use(log)

import moment from 'moment'
app.config.globalProperties.$moment = moment

// アイコンのライブラリ
import 'font-awesome/css/font-awesome.css'

// 予期せぬエラーに対応
app.config.errorHandler = function (err) {
  console.error(`---errorHandler ${err}`)
  router.replace({path: '/error'})
}

app.use(router)
app.use(store)
app.mount("#app")
